// import React, {useState, useCallback} from 'react';
import React, { useState, useEffect, useScroll, useCallback } from "react"
import {graphql, useStaticQuery, Link} from 'gatsby';
import styled from 'styled-components';
import Container from 'src/components/core/Container';
import theme from 'src/components/theme/theme';
import media from "styled-media-query";
import shadow from 'src/components/theme/shadows';
import Logo from 'src/components/layout/header/logo';

const StyledHeaderWrapper = styled.div`
    position: sticky;
    top: 0;
    background-color: white;
    z-index: 1000;
    box-shadow: ${shadow(10)};
    padding: 0.2rem 0;
`

const StyledLink = styled(Link)`
    text-decoration: none;
    color: unset;
`

const StyledContainer= styled(Container)`
    padding-top: 0;
    padding-bottom: 0;
`

const StyledHeader = styled.header`
position: relative;
  @media (min-width: 576px){
    display: flex;
  }
    justify-content: space-between;
margin: 0 0.5rem 0 0.5rem;
`
const StyledBar = styled.div`
width: 1.8rem;
height: 0.2rem;
border-radius: 5px;
background-color: black;
flex-grow: 0;
flex-shrink: 1;
`

// const InitialsWrapper = styled.div`
// ${Initials}:nth-child(2){
//     margin-top: 0.5rem;
// }
// `

const StyledInitials = styled.h2`
    font-family: 'Cinzel';
    font-size: 2rem;
    font-weight: normal;
    margin: 0.5rem 0;
`

const Initials = styled.h2`
    font-family: 'Cinzel';
    font-size: 3rem;
    padding: 0;
    margin: 0;
    font-weight: normal;
    display: inline-block;
    height: 2rem;
    span{
        height: 2rem;
        display: inline-block;
        font-size: 2.8rem;
        /* margin-top: 0.2rem; */
        max-width: 0;
        overflow: hidden;
    }
`

const StyledButton= styled.div`
    height: 1.5rem;
        opacity: ${props => props.opacity};
        @media screen and(min-width: 568px){
            opacity: 1;
        }
    width: 2rem;
    transition: all 0.5s;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    @media (min-width: 576px){
    display: none;
    };
    position: absolute;
    right: 0;
    top: 0.2rem;
`

const StyledNav = styled.nav`
    display: flex;
    flex-direction: column; 
    text-align: center; 
    overflow: hidden;
    transition: max-height 0.3s;
    @media (max-width: 576px){
    max-height: ${props => props.open ? "10rem" : "0"};
    }
    @media (min-width: 576px){
        flex-direction: row;
    };
    font-family: "Cinzel";
    a{
        line-height: 2;
    color: black;
        text-decoration: none;
        margin: 0 1rem;
    }
    
`


const Header = ()=>{
    const [open, setOpen] = useState(false)
    const memoizedOpen = useCallback(
        () => {
            // console.log(open)
          setOpen(!open);
        },
        [open],
      );
      const [opacity, setopacity] = useState("0")

  useEffect(() => {
    const timer = setTimeout(() => {
      setopacity(1)
    }, 2000)
    return () => clearTimeout(timer)
  }, [])
    return(
        <StyledHeaderWrapper>

            <StyledContainer>
        <StyledHeader>
        <StyledLink to="/">
            <Logo/>
        </StyledLink>
            <StyledButton opacity={opacity} onClick={
                memoizedOpen}>
                <StyledBar/>
                <StyledBar/>
                <StyledBar/>
            </StyledButton>
                <StyledNav open={open} opacity={opacity}>
                    <Link to="/about">About</Link>
                    <Link to="/sculpture">Sculpture</Link>
                    <Link to="/royalcoin">Royal Coin</Link>
                    <a href="https://martinjennings.co.uk/">Editions</a>
                    <Link to="/contact">Contact</Link>
                </StyledNav>
        </StyledHeader>
            </StyledContainer>
        </StyledHeaderWrapper>

    )
}

export default Header;